"use client";
import * as React from "react";
const SvgCodeSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 10", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M5.92 8.68 2.24 5l3.68-3.68L4.8.2 0 5l4.8 4.8zm4.16 0L13.76 5l-3.68-3.68L11.2.2 16 5l-4.8 4.8z" }));
export {
  SvgCodeSharp as default
};
